import React, { useState } from 'react';
import {
  Box,
  Button,
  Stack,
  TextField,
} from '@mui/material';
import { AVATAR_COLOR_PALETTE, resolveAvatarColor } from '../utils/userAvatar';

const AvatarColorPicker = ({
  value,
  onChange,
  onSave,
  saving = false,
}) => {
  const [customColor, setCustomColor] = useState(value || '#1E88E5');
  const selected = resolveAvatarColor(value);

  const pick = (color) => {
    onChange?.(color);
    setCustomColor(color);
  };

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(8, 1fr)',
          gap: 1,
          maxWidth: 360,
        }}
      >
        {AVATAR_COLOR_PALETTE.map((color) => (
          <Box
            key={color}
            role="button"
            tabIndex={0}
            aria-label={`Select color ${color}`}
            onClick={() => pick(color)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') pick(color); }}
            sx={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              bgcolor: color,
              cursor: 'pointer',
              border: '2px solid',
              borderColor: selected === color ? 'text.primary' : 'transparent',
              boxShadow: selected === color ? 2 : 0,
            }}
          />
        ))}
      </Box>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ sm: 'center' }}>
        <TextField
          label="Custom color"
          type="color"
          size="small"
          value={customColor}
          onChange={(e) => {
            setCustomColor(e.target.value);
            onChange?.(e.target.value);
          }}
          sx={{ width: 160 }}
        />
        <TextField
          label="Hex"
          size="small"
          value={customColor}
          onChange={(e) => {
            const v = e.target.value;
            setCustomColor(v);
            if (/^#[0-9A-Fa-f]{6}$/.test(v)) onChange?.(v);
          }}
          placeholder="#1E88E5"
          sx={{ width: 120 }}
        />
        {onSave && (
          <Button variant="contained" onClick={onSave} disabled={saving}>
            {saving ? 'Saving…' : 'Save color'}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default AvatarColorPicker;
